var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 0H3.66634C1.82834 0 0.333008 1.49533 0.333008 3.33333V12.6667C0.333008 14.5047 1.82834 16 3.66634 16H10.333C12.171 16 13.6663 14.5047 13.6663 12.6667V3.33333C13.6663 1.49533 12.171 0 10.333 0ZM3.66634 1.33333H10.333C11.4357 1.33333 12.333 2.23067 12.333 3.33333H1.66634C1.66634 2.23067 2.56367 1.33333 3.66634 1.33333ZM10.333 14.6667H3.66634C2.56367 14.6667 1.66634 13.7693 1.66634 12.6667V4.66667H12.333V12.6667C12.333 13.7693 11.4357 14.6667 10.333 14.6667ZM10.333 7.33333C10.333 7.702 10.0343 8 9.66634 8H4.33301C3.96501 8 3.66634 7.702 3.66634 7.33333C3.66634 6.96467 3.96501 6.66667 4.33301 6.66667H9.66634C10.0343 6.66667 10.333 6.96467 10.333 7.33333ZM7.66634 10C7.66634 10.3687 7.36768 10.6667 6.99968 10.6667H4.33301C3.96501 10.6667 3.66634 10.3687 3.66634 10C3.66634 9.63133 3.96501 9.33333 4.33301 9.33333H6.99968C7.36768 9.33333 7.66634 9.63133 7.66634 10Z",
    fill: "#808B99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notes-icon.5f95032a634b1984a189f99a2b627ebc.svg";
export { ForwardRef as ReactComponent };